import React, { Component } from 'react';
import { loadModules } from 'esri-loader';
import { getMapExtent } from '../../esri/mapHub';
import symbols from '../../../defaults/Symbols.json';

export class SpatialFilterMap extends Component
{
  constructor(props)
  {
     super(props);
     this.state =
     {
       mapIsLoaded: false,
     };

      this.mapRef = React.createRef();
      this.startup();
   }

   componentWillReceiveProps(nextProps)
   {
     if(!this.state.mapIsLoaded && nextProps.open && !this.props.open)
     {
       this.startup();
     }

     if (nextProps.selectedGeometry !== null && nextProps.selectedGeometry !== this.props.selectedGeometry) 
      {
        
        loadModules(['esri/geometry/Polygon']).then( ([Polygon]) => {
          
          debugger;
          const poly = new Polygon({
            rings: nextProps.selectedGeometry.rings,
            spatialReference: { wkid: 3857 }
          }); 
  
          this.spatialFilterGraphicsLayer.removeAll();
          this.spatialFilterGraphicsLayer.add({
            geometry: poly,
            symbol: symbols.selectedPerimeterSymbol
          });
          this.view.extent = poly.extent.expand(1.4);
        });
      } 
   }

   shouldComponentUpdate(nextProps, nextState)
   {
     return false;
   }

   componentWillUnmount()
   {
     // Clean up jsapi's dirty little mess
   }

   render()
   {
     return (
       <div className="webmap" id="viewContainer" style={{height: "100%", width: "100%"}} ref={this.mapRef}></div>
     );
   }

  startup = () =>
  {
    loadModules([
      'esri/Map',
      'esri/views/MapView',
      'esri/widgets/BasemapToggle',
      'esri/layers/GraphicsLayer'], { css: true })
   .then(([
     ArcGISMap,
     MapView,
     BasemapToggle,
     GraphicsLayer
     ]) =>
   {
     const map = new ArcGISMap({
       basemap: 'topo-vector'
     });

     this.view = new MapView({
       container: this.mapRef.current,
       map: map,
       center: [-118, 34],
       zoom: 8
     });

     this.basemapToggle = new BasemapToggle({
        view: this.view
      });

     this.map = this.view.map;
     this.view.ui.add(this.basemapToggle, 'bottom-right');

     this.spatialFilterGraphicsLayer = new GraphicsLayer();
     map.add(this.spatialFilterGraphicsLayer);

     //Set map extent to main map extent
     getMapExtent().then(
      result =>
        {
          this.view.extent = result;
        }
      );

     this.setState({
       mapIsLoaded: true
     });
   }

   );
 }
}

export default SpatialFilterMap;
